export default __webpack_public_path__ + "static/media/masterballHolo.6ab072bc.svg";